import { WidgetType } from "../../../../../services/cloudchipr.api";

export const dashboardWidgetLabels: Partial<Record<WidgetType, string>> = {
  costs_by_category_v2: "Cost By Category",
  cost_breakdown: "Cost Breakdown",
  cost_and_usage_summary: "Cost and usage summary",
  largest_cost_changes: "Largest cost changes",
};
